import DogService from 'components/dog/dog-service';
import { Tapibutton } from 'components/Tapibutton';
import { TouchEvent, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './dog.module.scss';

export const Dog = () => {
  const [dogImage, setDogImage] = useState<string>();
  const [animationKey, setAnimationKey] = useState<number>(0);
  let touchStartPosition = 0;

  const loadImage = async () => {
    const dog = await DogService.loadImages();
    setDogImage(dog.message);
    setAnimationKey(prev => prev + 1); // wichtig für Animation bei Bildwechsel
  };

  const touchStart = (e: TouchEvent) => {
    e.preventDefault();
    const touch = e.touches[0] || e.changedTouches[0];
    touchStartPosition = touch.clientX;
  };

  const touchEnd = (e: TouchEvent) => {
    const touch = e.touches[0] || e.changedTouches[0];
    touchStartPosition = 0;
    loadImage();
  };

  useEffect(() => {
    loadImage();
  }, []);

  return (
    <div className={styles.dog}>
      <div className="image-wrapper">
        <AnimatePresence mode="wait">
          {dogImage && (
            <motion.img
              key={animationKey}
              src={dogImage}
              alt="dog"
              onTouchEnd={touchEnd}
              onTouchStart={touchStart}
              onClick={loadImage}
              initial={{ x: 300, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: -300, opacity: 0 }}
              transition={{ duration: 0.5 }}
              className="image"
            />
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};
